import { types } from 'mobx-state-tree';

import CREDIT_BUREAUS from '../definitions/CreditBureaus';


export default types.enumeration('CreditBureau', Object.values(CREDIT_BUREAUS));
